module.exports = __webpack_public_path__ + "static/media/hc_logo_white.1d101647.svg";